import React from 'react';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tag, notification } from 'antd';
import moment from 'moment';
import { PricingAPI } from '../../../controller/PricingAPI';

const DATE_FORMAT = 'YYYY-MM-DD';

const FAILURE_LABELS = {
  invalid_credentials: '密碼錯誤',
  unknown_email: '查無帳號',
};

export default function LoginLogPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [pagination, setPagination] = React.useState({ current: 1, pageSize: 50, total: 0 });

  const query = React.useCallback((page, pageSize, values) => {
    const filters = values || form.getFieldsValue();
    const range = filters.range;

    setLoading(true);
    PricingAPI.loginLogs.index(
      {
        email: filters.email || undefined,
        // 未選擇時不帶參數，才不會把「全部」誤送成 success=0
        success: filters.success === undefined || filters.success === '' ? undefined : filters.success,
        from: range && range[0] ? range[0].format(DATE_FORMAT) : undefined,
        to: range && range[1] ? range[1].format(DATE_FORMAT) : undefined,
      },
      page,
      pageSize
    ).then((response) => {
      const result = response.data;
      setRows(result.data);
      setPagination({ current: result.current_page, pageSize: result.per_page, total: result.total });
    }).catch((error) => {
      notification.error({
        message: '查詢失敗',
        description: error?.response?.data?.message || '請稍後再試',
      });
    }).finally(() => {
      setLoading(false);
    });
  }, [form]);

  React.useEffect(() => {
    query(1, 50, {});
  }, [query]);

  const columns = [
    {
      title: '時間',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
    },
    { title: '帳號', dataIndex: 'email', key: 'email' },
    {
      title: '名稱',
      dataIndex: 'user',
      key: 'user',
      render: (user) => (user ? user.name : '-'),
    },
    {
      title: '結果',
      dataIndex: 'success',
      key: 'success',
      render: (success, record) => (success
        ? <Tag color="green">成功</Tag>
        : <Tag color="red">{FAILURE_LABELS[record.failure_reason] || '失敗'}</Tag>),
    },
    { title: 'IP', dataIndex: 'ip', key: 'ip' },
    {
      title: '瀏覽器',
      dataIndex: 'user_agent',
      key: 'user_agent',
      ellipsis: true,
    },
  ];

  return (
    <div>
      <h1>登入記錄</h1>
      <Form form={form} layout="inline" style={{ marginBottom: 15 }} onFinish={(values) => query(1, pagination.pageSize, values)}>
        <Form.Item name="email">
          <Input placeholder="帳號" allowClear style={{ width: 200 }} />
        </Form.Item>
        <Form.Item name="success">
          <Select
            placeholder="結果"
            allowClear
            style={{ width: 120 }}
            options={[
              { value: 1, label: '成功' },
              { value: 0, label: '失敗' },
            ]}
          />
        </Form.Item>
        <Form.Item name="range">
          <DatePicker.RangePicker />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">查詢</Button>
            <Button onClick={() => { form.resetFields(); query(1, pagination.pageSize, {}); }}>清除</Button>
          </Space>
        </Form.Item>
      </Form>
      <Row>
        <Col span={24}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={rows}
            loading={loading}
            size="small"
            scroll={{ x: 'max-content' }}
            pagination={{ ...pagination, showSizeChanger: true, pageSizeOptions: ['50', '100', '200'] }}
            onChange={(next) => query(next.current, next.pageSize)}
          />
        </Col>
      </Row>
    </div>
  );
}
